import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	description: {
		id: 'error-boundary.flag.description',

		defaultMessage:
			'If this keeps happening, share this information with your admin, who should <link>contact support</link>.',
		description: '',
	},
	header: {
		id: 'error-boundary.flag.header',
		defaultMessage: 'Something went wrong on our end',
		description: '',
	},
	reloadPageButton: {
		id: 'error-boundary.flag.reload-page-button',
		defaultMessage: 'Reload page',
		description: '',
	},
});
